/* ============================================================
   Aire de Agua — PDP controller (theme Focal / preset Ivory)
   Estático y cacheable: inicializa cada .adea-pdp de la página.
   Lee datos por data-* y por el <script data-adea-variants> hijo.
   ============================================================ */
(function () {
  function initRoot(root) {
    var variants = [];
    var dataEl = root.querySelector('[data-adea-variants]');
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput     = root.querySelector('[data-adea-id]');
    var priceEl     = root.querySelector('[data-adea-price]');
    var addBtn      = root.querySelector('[data-adea-add]');
    var addLabel    = root.querySelector('[data-adea-add-label]');
    var urgency     = root.querySelector('[data-adea-urgency]');
    var urgencyText = root.querySelector('[data-adea-urgency-text]');
    var hero        = root.querySelector('[data-adea-hero]');
    var heroVideo   = root.querySelector('[data-adea-hero-video]');
    var groups      = Array.prototype.slice.call(root.querySelectorAll('[data-adea-group]'));
    var threshold   = parseInt(root.dataset.threshold, 10) || 0;
    var urgencyTpl  = root.dataset.urgencyText || '';
    var stickyPrice = root.querySelector('[data-adea-sticky-price]');
    var stickyAdd   = root.querySelector('[data-adea-sticky-add]');
    var stickyBar   = root.querySelector('[data-adea-sticky]');
    var form        = root.querySelector('[data-adea-form]');
    var qtyInput    = root.querySelector('[data-adea-qty-input]');

    function currentSelection() {
      var sel = [];
      groups.forEach(function (g) {
        var checked = g.querySelector('input:checked');
        sel[parseInt(g.dataset.adeaGroup, 10)] = checked ? checked.value : null;
      });
      return sel;
    }

    function exactVariant(sel) {
      // Producto de variante única (sin talla/color): no hay grupos que matchear.
      // Shopify le asigna la opción interna "Default Title" (options.length === 1),
      // así que el match nunca daría (1 === 0). Usamos directamente la única variante.
      if (groups.length === 0) return variants[0];
      return variants.find(function (v) {
        return v.options.length === sel.length && v.options.every(function (o, i) { return o === sel[i]; });
      });
    }

    function valueAvailable(groupIndex, value) {
      var sel = currentSelection();
      sel[groupIndex] = value;
      return variants.some(function (v) {
        var matches = sel.every(function (s, i) { return s == null || v.options[i] === s; });
        return matches && v.available;
      });
    }

    function refreshPillStates() {
      groups.forEach(function (g) {
        var gi = parseInt(g.dataset.adeaGroup, 10);
        g.querySelectorAll('[data-adea-pill]').forEach(function (pill) {
          var ok = valueAvailable(gi, pill.dataset.value);
          pill.classList.toggle('is-soldout', !ok);
          var input = pill.querySelector('input');
          if (input) input.disabled = !ok;
        });
      });
    }

    function setActiveClasses() {
      root.querySelectorAll('[data-adea-swatch]').forEach(function (el) {
        var input = el.querySelector('input');
        el.classList.toggle('is-active', input && input.checked);
      });
      root.querySelectorAll('[data-adea-pill]').forEach(function (el) {
        var input = el.querySelector('input');
        el.classList.toggle('is-active', input && input.checked && !el.classList.contains('is-soldout'));
      });
      groups.forEach(function (g) {
        var lbl = g.querySelector('[data-adea-selected]');
        var checked = g.querySelector('input:checked');
        if (lbl && checked) lbl.textContent = checked.value;
      });
    }

    function setSoldOut(state) {
      if (addBtn) {
        addBtn.disabled = state;
        addBtn.classList.toggle('is-soldout', state);
      }
      if (addLabel) addLabel.textContent = state ? 'Agotado' : 'Añadir al carrito';
      if (stickyAdd) { stickyAdd.disabled = state; stickyAdd.textContent = state ? 'Agotado' : 'Añadir'; }
    }

    // ---- Galería: filtra por color (alt "#color_x") y navega con swipe ----
    var thumbEls   = Array.prototype.slice.call(root.querySelectorAll('[data-adea-thumb]'));
    var dotEls     = Array.prototype.slice.call(root.querySelectorAll('[data-adea-dot]'));
    var visOrder   = [];   // índices de media visibles, en orden
    var visPos     = 0;    // puntero dentro de visOrder
    var lastColor  = null; // último color aplicado a la galería

    function selectedColor() {
      var el = root.querySelector('[data-adea-option][data-color-code]:checked');
      return el ? (el.dataset.colorCode || '') : '';
    }

    function galleryShow(idx) {
      idx = String(idx);
      var thumb = root.querySelector('[data-adea-thumb="' + idx + '"]');
      var isVideo = !!(thumb && thumb.dataset.mediaType === 'video' && thumb.dataset.videoSrc);

      if (isVideo && heroVideo) {
        // Carga la fuente solo la primera vez: evita re-descargar al volver al slide.
        if (heroVideo.getAttribute('src') !== thumb.dataset.videoSrc) {
          heroVideo.setAttribute('src', thumb.dataset.videoSrc);
          heroVideo.poster = thumb.dataset.src || '';
        }
        if (hero) hero.hidden = true;
        heroVideo.hidden = false;
        // play() devuelve promesa: si el navegador bloquea el autoplay, quedan poster + controles.
        var p = heroVideo.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        if (heroVideo) { heroVideo.pause(); heroVideo.hidden = true; }
        if (hero) {
          hero.hidden = false;
          if (thumb && thumb.dataset.src) {
            hero.src = thumb.dataset.src;
            hero.removeAttribute('srcset');
          }
        }
      }

      thumbEls.forEach(function (t) { t.classList.toggle('is-active', t.dataset.adeaThumb === idx); });
      dotEls.forEach(function (d) { d.classList.toggle('is-active', d.dataset.adeaDot === idx); });
      visPos = visOrder.indexOf(idx);
      if (visPos < 0) visPos = 0;
    }

    function galleryApplyColor(code) {
      code = (code || '').toLowerCase();
      visOrder = [];
      thumbEls.forEach(function (t) {
        var c = (t.dataset.color || '').toLowerCase();
        var match = !code || !c || c === code;   // sin color = compartida, visible siempre
        t.hidden = !match;
        if (match) visOrder.push(t.dataset.adeaThumb);
      });
      dotEls.forEach(function (d) {
        var c = (d.dataset.color || '').toLowerCase();
        d.hidden = !(!code || !c || c === code);
      });
      if (visOrder.length) galleryShow(visOrder[0]);
    }

    function galleryStep(delta) {
      if (visOrder.length < 2) return;
      var np = Math.min(visOrder.length - 1, Math.max(0, visPos + delta));
      if (np !== visPos) galleryShow(visOrder[np]);
    }

    // Swipe táctil + tap para abrir el zoom
    var justSwiped = false;
    if (hero) {
      var sx = null, sy = null;
      hero.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0]; sx = t.clientX; sy = t.clientY;
      }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (sx == null) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          justSwiped = true; setTimeout(function () { justSwiped = false; }, 300);
          galleryStep(dx < 0 ? 1 : -1);
        }
        sx = sy = null;
      }, { passive: true });
      hero.addEventListener('click', function () { if (!justSwiped) openLightbox(); });
    }

    // Swipe también sobre el video: si no, en móvil la clienta queda atrapada en su slide.
    if (heroVideo) {
      var vsx = null, vsy = null;
      heroVideo.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0]; vsx = t.clientX; vsy = t.clientY;
      }, { passive: true });
      heroVideo.addEventListener('touchend', function (e) {
        if (vsx == null) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - vsx, dy = t.clientY - vsy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) galleryStep(dx < 0 ? 1 : -1);
        vsx = vsy = null;
      }, { passive: true });
    }

    // ---- Lightbox de zoom: misma foto a mayor tamaño (pide 2000px) ----
    var lb = null, lbImg = null;
    function zoomSrc() {
      var s = (hero && hero.getAttribute('src')) || '';
      return /[?&]width=\d+/.test(s) ? s.replace(/([?&]width=)\d+/, '$12000') : s;
    }
    function buildLightbox() {
      lb = document.createElement('div');
      lb.className = 'adea-lightbox';
      lb.innerHTML = '<button type="button" class="adea-lightbox__close" aria-label="Cerrar">×</button><img class="adea-lightbox__img" alt="">';
      lbImg = lb.querySelector('.adea-lightbox__img');
      lb.addEventListener('click', function (e) {
        if (e.target === lb || e.target.classList.contains('adea-lightbox__close')) closeLightbox();
      });
      // Tap/click alterna 1x <-> 2x; en desktop el mouse desplaza el encuadre.
      lbImg.addEventListener('click', function (e) { e.stopPropagation(); lbImg.classList.toggle('is-zoomed'); });
      lbImg.addEventListener('mousemove', function (e) {
        if (!lbImg.classList.contains('is-zoomed')) return;
        var r = lbImg.getBoundingClientRect();
        lbImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLightbox(); });
      root.appendChild(lb);
    }
    function openLightbox() {
      if (!hero || hero.hidden) return;   // no abrir zoom sobre un video
      if (!lb) buildLightbox();
      lbImg.classList.remove('is-zoomed');
      lbImg.style.transformOrigin = 'center';
      lbImg.src = zoomSrc();
      lb.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    }
    function closeLightbox() {
      if (lb) lb.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }

    function update() {
      var sel = currentSelection();
      var variant = exactVariant(sel);
      refreshPillStates();

      // Al cambiar de color, refiltra la galería a las fotos de ese color.
      var color = selectedColor();
      if (color !== lastColor) { galleryApplyColor(color); lastColor = color; }

      if (!variant) {
        setSoldOut(true);
        if (addLabel) addLabel.textContent = 'No disponible';
        if (idInput) idInput.value = '';
        if (urgency) urgency.hidden = true;
        setActiveClasses();
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.innerHTML = variant.price_html;
      if (stickyPrice) stickyPrice.textContent = variant.price_short;
      setSoldOut(!variant.available);

      // Urgencia: solo inventario gestionado, en stock y bajo umbral. Nunca inventada.
      if (urgency) {
        if (variant.available && variant.inv_managed && threshold > 0 && variant.inv_qty > 0 && variant.inv_qty <= threshold) {
          urgencyText.textContent = urgencyTpl.replace('{qty}', variant.inv_qty);
          urgency.hidden = false;
        } else {
          urgency.hidden = true;
        }
      }
      setActiveClasses();
    }

    root.querySelectorAll('[data-adea-option]').forEach(function (input) {
      input.addEventListener('change', update);
    });

    root.querySelectorAll('[data-adea-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.dataset.adeaQty, 10);
        var val = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta);
        qtyInput.value = val;
      });
    });

    thumbEls.forEach(function (t) {
      t.addEventListener('click', function () { galleryShow(t.dataset.adeaThumb); });
    });
    dotEls.forEach(function (d) {
      d.addEventListener('click', function () { galleryShow(d.dataset.adeaDot); });
    });

    if (stickyBar && 'IntersectionObserver' in window) {
      var ctaRow = root.querySelector('.adea-cta__row');
      if (ctaRow) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            stickyBar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
          });
        }, { threshold: 0 });
        io.observe(ctaRow);
      }
    }

    // Añadir al carrito por AJAX (progresivo: sin JS el form postea a /cart normal)
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!idInput || !idInput.value) return;
        e.preventDefault();
        var btns = [addBtn, stickyAdd].filter(Boolean);
        btns.forEach(function (b) { b.disabled = true; });
        fetch(root.dataset.addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: idInput.value, quantity: parseInt(qtyInput.value, 10) || 1 })
        }).then(function (r) { return r.json(); }).then(function (data) {
          if (data && data.status) {
            btns.forEach(function (b) { b.disabled = false; });
            if (addLabel) addLabel.textContent = data.description || 'No disponible';
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
          window.location = root.dataset.cartUrl;
        }).catch(function () {
          window.location = root.dataset.cartUrl;
        });
      });
    }

    update();
  }

  function initAll() {
    document.querySelectorAll('.adea-pdp').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
